/**
 * FXB Mega Menu
 * Handles Shop dropdown on desktop (hover + keyboard) and mobile (tap to expand).
 * Vanilla JS, no dependencies.
 */

(function () {
  'use strict';

  const HOVER_CLOSE_DELAY = 180;       // ms — small delay so cursor can travel
  const MOBILE_BREAKPOINT = 900;       // matches CSS breakpoint

  function init() {
    const groups = document.querySelectorAll('[data-nav-group]');
    if (groups.length === 0) return;

    groups.forEach(group => wireGroup(group));

    // Close on Escape globally
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        groups.forEach(g => closeGroup(g));
      }
    });

    // Close on outside click (desktop only — mobile uses accordion)
    document.addEventListener('click', (e) => {
      if (isMobile()) return;
      groups.forEach(g => {
        if (!g.contains(e.target)) closeGroup(g);
      });
    });
  }

  function wireGroup(group) {
    const trigger = group.querySelector('[data-nav-trigger]');
    const menu = group.querySelector('[data-mega-menu]');
    if (!trigger || !menu) return;

    let closeTimer = null;

    const openGroup = () => {
      clearTimeout(closeTimer);
      group.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => closeGroup(group), HOVER_CLOSE_DELAY);
    };

    // Desktop: hover
    group.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      openGroup();
    });
    group.addEventListener('mouseleave', () => {
      if (isMobile()) return;
      scheduleClose();
    });

    // Trigger click:
    //   - Desktop: let the link navigate (href="/collections/all") normally
    //             UNLESS the chevron area was clicked (prevents accidental navigation while browsing dropdown)
    //   - Mobile: intercept and toggle the accordion
    trigger.addEventListener('click', (e) => {
      if (isMobile()) {
        e.preventDefault();
        if (group.getAttribute('data-open') === 'true') {
          closeGroup(group);
        } else {
          // Close any other open groups first
          document.querySelectorAll('[data-nav-group][data-open="true"]').forEach(g => {
            if (g !== group) closeGroup(g);
          });
          openGroup();
        }
      }
      // Desktop: don't intercept — let the "Shop" link navigate to /collections/all
    });

    // Keyboard: Arrow Down opens the menu, Escape closes it
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        if (!isMobile() && e.key === 'ArrowDown') {
          e.preventDefault();
          openGroup();
          // Focus first item
          const firstItem = menu.querySelector('a');
          if (firstItem) firstItem.focus();
        }
      }
    });

    // If focus leaves the menu entirely (via Tab), close it
    group.addEventListener('focusout', (e) => {
      if (isMobile()) return;
      // e.relatedTarget is the element that will receive focus
      if (!group.contains(e.relatedTarget)) {
        scheduleClose();
      }
    });
  }

  function closeGroup(group) {
    group.removeAttribute('data-open');
    const trigger = group.querySelector('[data-nav-trigger]');
    const menu = group.querySelector('[data-mega-menu]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.setAttribute('aria-hidden', 'true');
  }

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
  }

  // When window is resized across the breakpoint, close all groups to reset state
  let lastIsMobile = isMobile();
  window.addEventListener('resize', () => {
    const nowMobile = isMobile();
    if (nowMobile !== lastIsMobile) {
      document.querySelectorAll('[data-nav-group]').forEach(closeGroup);
      lastIsMobile = nowMobile;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
